
import * as Sentry from '@sentry/vue'
import { Component, Vue, Prop } from 'vue-property-decorator'
import BISTable from '@/components/bis_table.vue'
import LeaveTeam from '@/components/modals/confirmations/leave_team.vue'
import TeamMember from '@/interfaces/team_member'
import { ImportError } from '@/interfaces/imports'

@Component({
  components: {
    BISTable,
  },
})
export default class TeamMemberCard extends Vue {
  active = false

  @Prop()
  details!: TeamMember

  @Prop()
  maxItemLevel!: number

  @Prop()
  teamId!: number

  @Prop()
  viewerIsLead!: boolean

  get displayFooter(): boolean {
    // Check all the link cases in the footer and if none of them are true, we don't want to render the card footer at all
    return (
      this.details.bis_list.external_link != null
      || this.owner
      || (this.viewerIsLead && !this.owner)
    )
  }

  leave(): void {
    this.$modal.show(LeaveTeam, { details: this.details, teamId: this.teamId })
  }

  async lodestoneUpdate(): Promise<void> {
    try {
      const response = await fetch(`${process.env.VUE_APP_URL}/backend/api/team/${this.teamId}/member/${this.details.id}/gear_update/`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'X-CSRFToken': this.$cookies.get('csrftoken'),
        },
      })

      if (response.ok) {
        this.$notify({ text: `Current Gear pulled from Lodestone for ${this.details.name}!`, type: 'is-success' })
      }
      else {
        const error = await response.json() as ImportError
        if (response.status === 406) {
          this.$notify({ text: error.message, type: 'is-link' })
        }
        else {
          // Only add the "Error while ..." text when it's not for the wrong job error
          this.$notify({ text: `Error while importing Lodestone gear; ${error.message}`, type: 'is-danger' })
        }
      }
    }
    catch (e) {
      this.$notify({ text: `Error ${e} when attempting to import Lodestone data.`, type: 'is-danger' })
      Sentry.captureException(e)
    }
  }

  // Flag stating whether the logged in user is the owner of the member on this card
  get owner(): boolean {
    return this.$store.state.user.id === this.details.character.user_id
  }

  toggleDropdown(): void {
    this.active = !this.active
  }
}
